import { render, staticRenderFns } from "./IcoCalloutQuestionMark.vue?vue&type=template&id=88ef117c"
import script from "./IcoCalloutQuestionMark.vue?vue&type=script&lang=js"
export * from "./IcoCalloutQuestionMark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports